/**
 * @file 为 packages/route 中的各种 hook 注入了路由类型信息
 */

/* eslint-disable no-restricted-imports */

import {
  useHistory as useHistoryRaw,
  getPath as getPathRaw,
  useRouteModalHistory as useRouteModalHistoryRaw,
  useRouteModalParams as useRouteModalParamsRaw,
  useParams as useParamsRaw,
  useLocation as useLocationRaw,
} from 'packages/route'

import { RouteModalParams, RouteParams } from './types'

export const getPath = <TName extends keyof RouteParams>(
  name: TName,
  params: RouteParams[TName]
) => getPathRaw<RouteParams, TName>(name, params)

export const useHistory = () => useHistoryRaw<RouteParams>()

export const useParams = <TName extends keyof RouteParams>() =>
  useParamsRaw<RouteParams, TName>()

export const useLocation = useLocationRaw

export const useRouteModalHistory = () =>
  useRouteModalHistoryRaw<RouteModalParams>()

export const useRouteModalParams = <TName extends keyof RouteModalParams>(
  defaultQuery: Partial<RouteModalParams[TName]> = {}
) => useRouteModalParamsRaw<RouteModalParams, TName>(defaultQuery)
